import React, { useState, useEffect } from "react";
import "./footer.scss";
import NewImage from "../../assets/icons/99.svg";
import NewImage1 from "../../assets/icons/260.svg";
import EmailIcon from "../../assets/icons/email.svg";
import WhatsappIcon from "../../assets/icons/whatsapp.svg";
import FacebookIcon from "../../assets/icons/facebook copy.svg";
import InstaIcon from "../../assets/icons/insta.svg";
import LinkdinIcon from "../../assets/icons/linkdin.svg";
import WhiteLogo from "../../assets/logo/white-logo.svg";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";

import { NavLink } from "react-router-dom";
export default function Footer() {
  const [contactData, setContactData] = useState({});
  const [errors, setErrors] = useState({});
  const [showErrors, setShowErrors] = useState(false);
  const [cardsData, setCardsData] = useState([]);

  useEffect(() => {
    propertyCardSlider();
  }, []);

  const propertyCardSlider = async () => {
    await axios
      .get(`https://api.deutscher.rejoicehub.com/api/v1/icon/find`)
      .then((res) => {
        setCardsData(res?.data?.payload?.data);
        console.log("cardsDataaa", res?.data?.payload?.data);
      })
      .catch((error) => console.log(error));
  };
  console.log("cardsData", cardsData);

  const clearData = () => {
    setContactData({
      firstname: "",
      email: "",
      telephone: "",
      Nachricht: "",
    });
  };

  const handleChange = (e) => {
    setContactData({ ...contactData, [e.target.name]: e.target.value });

    setErrors({ ...errors, [e.target.name]: "" });
  };
  console.log("contactData", contactData);
  const regex =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  const handleContactUs = async () => {
    if (
      !contactData.firstname &&
      !contactData.email &&
      !contactData.telephone &&
      !contactData.Nachricht
    ) {
      setErrors({
        ...errors,
        firstname: "Bitte überprüfen Sie ihre Eingabe.",
        email: "Bitte überprüfen Sie ihre Eingabe.",
        telephone: "Bitte überprüfen Sie ihre Eingabe.",
        Nachricht: "Bitte überprüfen Sie ihre Eingabe.",
      });
      setShowErrors(true);
    } else if (!contactData.firstname) {
      setErrors({ ...errors, firstname: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.email) {
      setErrors({ ...errors, email: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!regex.test(contactData.email)) {
      setErrors({ ...errors, email: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.telephone || contactData.telephone?.length > 14) {
      // toast.error("Please Enter your Last Name");
      setErrors({ ...errors, telephone: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.Nachricht) {
      // toast.error("Please Enter your Last Name");
      setErrors({ ...errors, Nachricht: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else {
      const body = {
        name: contactData.firstname,
        email: contactData.email,
        phone: parseInt(contactData.telephone),
        news: contactData.Nachricht,
      };
      console.log("opp", body);
      // toast.success("Nachricht erfolgreich versendet");

      await axios
        .post("https://api.deutscher.rejoicehub.co/contact-us/create", body)
        .then((res) => {
          console.log(res);
          setContactData({});
          clearData();
          toast.success("Nachricht erfolgreich versendet");
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  return (
    <>
      <Toaster />
      <div className="update-footer-design">
        <div className="container-lg-10">
          <div className="update-footer-grid">
            <div className="update-footer-grid-items">
              <div className="footer-update-style">
                <h2>Hier finden Sie uns:</h2>
              </div>
              <div className="des-details">
                <p>DEUTSCHER IMMOBILIEN DIENST GmbH</p>
                <p>Teerhof 59</p>
                <p>28199 Bremen</p>
              </div>
              <div className="new-text-style">
                <a href="tel:0421 / 1 67 61 80-0">
                  <span>Telefon:</span>0421 / 1 67 61 80-0
                </a>
                <a href="mailto: info@did-24.de?subject = Feedback&body = Message">
                  <span>E-Mail: </span>info@did-24.de
                </a>
              </div>
              <div className="office-add">
                <p>Öffnungszeiten:</p>
                <span>
                  <a>Mo - Do</a> Nur nach Vereinbarung
                </span>
                <span>
                  <a>Freitag Nur</a> nach Vereinbarung
                </span>
                <span>
                  <a>Sa - So</a> Nur nach Vereinbarung
                </span>
              </div>
              <div className="new-button">
                <NavLink to="/kontakt-formular">
                  <button>Erstellen Sie einen Suchauftrag</button>
                </NavLink>
              </div>
              <div className="new-footer-image-center-alignment">
                <a
                  href="https://www.immobilienscout24.de/anbieter/hansa-real-estate-gmbh/aa80c935370a444155d50c5?cmp_id=10-04268&cmp_name=residential_realtordirectory&cmp_position=residential_expose&cmp_creative=logo_to_rd_main-realtorinfo"
                  target="_blank"
                >
                  <img src={NewImage1} atl="NewImage1" />
                </a>
                <a
                  href="https://www.immowelt.de/profil/7845086"
                  target="_blank"
                >
                  <img
                    className="footer-last-image-alignment"
                    src={NewImage}
                    atl="NewImage"
                  />
                </a>
              </div>
            </div>
            <div className="update-footer-grid-items">
              <div className="three-text-alignment">
                <h3>Ihre Nachricht an uns:</h3>
              </div>
              <div className="all-input-alignment">
                <div className="input">
                  <input
                    type="text"
                    placeholder="Name"
                    name="firstname"
                    value={contactData.firstname && contactData.firstname}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.firstname}
                    </span>
                  )}
                </div>
                <div className="input">
                  <input
                    type="text"
                    placeholder="E-Mail-Adresse"
                    name="email"
                    value={contactData.email && contactData.email}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.email}
                    </span>
                  )}
                </div>
                <div className="input">
                  <input
                    type="number"
                    placeholder="Telefon"
                    className="remove-counter"
                    name="telephone"
                    value={contactData.telephone && contactData.telephone}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.telephone}
                    </span>
                  )}
                </div>
                <div className="input">
                  <input
                    type="text"
                    placeholder="Nachricht"
                    name="Nachricht"
                    value={contactData.Nachricht && contactData.Nachricht}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.Nachricht}
                    </span>
                  )}
                </div>
              </div>
              <div className="button-global-new-style">
                <button className="white-button" onClick={handleContactUs}>
                  senden
                </button>
              </div>
              <div className="button-global-new-style">
                <a href="tel:0421 1 67 61 800">
                  <button className="outline-button">
                    Oder rufen Sie uns gerne an!
                  </button>
                </a>
              </div>
              <div className="all-social-media-icon-alignment">
                <div>
                  <a
                    href={`mailto:${cardsData?.[3]?.link}?subject = Feedback&body = Message`}
                  >
                    <img src={EmailIcon} alt="EmailIcon" />
                  </a>
                </div>
                {/* <div>
                  <a href={`tel:${cardsData?.[1]?.link}`}>
                    <img src={WhatsappIcon} alt="WhatsappIcon" />
                  </a>
                </div>
                <div>
                  <a href={cardsData?.[4]?.link} target="_blank">
                    <img src={FacebookIcon} alt="FacebookIcon" />
                  </a>
                </div>

                <div>
                  <a href={cardsData?.[0]?.link} target="_blank">
                    <img src={InstaIcon} alt="InstaIcon" />
                  </a>
                </div>
                <div>
                  <a href={cardsData?.[2]?.link} target="_blank">
                    <img src={LinkdinIcon} alt="LinkdinIcon" />
                  </a>
                </div> */}
              </div>
              <div className="white-logo-center-alignment">
                <img src={WhiteLogo} alt="WhiteLogo" />
              </div>
            </div>
          </div>
          <div className="footer-last-text-alignment">
            <NavLink to="/immpressum-page">Impressum</NavLink>
            <p>Copyright DID © Alle Rechte vorbehalten.</p>
          </div>
        </div>
      </div>
      {/* <div className="footer-design">
        <div className="container-lg-8">
          <div className="grid">
            <div className="left-side-footer-content">
              <div className="grid-items">
                <h2>
                  Sie haben <br /> Fragen?
                </h2>
                <NavLink to="/kontakt">Kontaktformular</NavLink>
              </div>
              <div className="grid-items">
                <h2>Rechtliches</h2>
                <NavLink to="/immpressum-page">Impressum</NavLink>
                <NavLink to="/haftubgasausshluss">Haftungsausschluss</NavLink>
              </div>
              <div className="grid-items">
                <h2>DID</h2>
                <a>
                  Teerhof 59 <br />
                  28199 Bremen
                </a>
                <br />
                <a href="tel: 0421 1 6761 80-0">Telefon 0421 1 6761 80-0</a>
                <a>Fax 0421 1 6761 80-9</a>
                <a href="mailto:info@did-24.de?subject = Feedback&body = Message">
                  E-Mail info@did-24.de
                </a>
              </div>
            </div>

            <div className="grid-items grid-items-last-footer">
              <a
                href="https://www.immobilienscout24.de/anbieter/hansa-real-estate-gmbh/aa80c935370a444155d50c5?cmp_id=10-04268&cmp_name=residential_realtordirectory&cmp_position=residential_expose&cmp_creative=logo_to_rd_main-realtorinfo"
                target="_blank"
              >
                <img src={NewImage1} atl="NewImage1" />
              </a>
              <a href="https://www.immowelt.de/profil/7845086" target="_blank">
                <img
                  className="footer-last-image-alignment"
                  src={NewImage}
                  atl="NewImage"
                />
              </a>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}
